/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { Box, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import {
  ErrorMessage,
  ImageDiv,
  ImageDivText,
  InputContainer,
  InputContainer1,
  InputDiv,
  InputDiv1,
  InputFieldDiv,
  InputLevel,
} from "./Volunteer.style";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PhotoCamera } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ThemButton } from "../Login/Login.style";
import { useDispatch } from "react-redux";
import { handleAddClose } from "../../redux/Reducer/ModalSlice";
import { useQuery } from "@tanstack/react-query";
import SyncLoader from "react-spinners/SyncLoader";
import { toast, ToastContainer, Zoom } from "react-toastify";
import useVolunteerPending from "../../hooks/useVolunteerPending";
import StyledInput from "../Share/StyledInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "react-toastify/dist/ReactToastify.css";

const schema = yup.object().shape({
  dor: yup
    .date()
    .required("Date of registration is required")
    .max(new Date(), "Date of registration must not future date"),

  full_name: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long"),

  father_name: yup
    .string()
    .required("Father name is required")
    .min(3, "Father name must be at least 3 characters long"),

  marital_status: yup.string().required("Marital status is required"),

  dob: yup
    .date()
    .required("Date of birth is required")
    .max(new Date(), "Date of birth must not future date"),

  sex: yup.string().required("Sex is required"),

  v_fathr_or_husb_name: yup
    .string()
    .min(3, "Father/Husband Name must be at least 3 characters long"),

  fathr_or_husb_nid: yup
    .string()
    .min(9, "Father/Husband NID No. must be at least 9 digits")
    .max(20, "Father/Husband NID No. must be at most 20 digits"),

  vol_blood_group: yup.string().required("Blood group is required"),

  occupation_name: yup.string().required("Occupation name is required"),

  national_id: yup
    .string()
    .required("NID No. is required")
    .min(9, "NID No. must be at least 9 digits")
    .max(20, "NID No. must be at most 20 digits"),

  contact_phone: yup
    .string()
    .required("Contact Number is required")
    .matches(/^\d{11}$/, "Phone number must be exactly 11 digits"),

  emergency_contract_ph: yup
    .string()
    .required("Relative Phone number is required")
    .matches(/^\d{11}$/, "Relative Phone number must be exactly 11 digits"),

  emergency_contract_nm: yup
    .string()
    .required("Emergency Contract Person Name is required")
    .min(
      3,
      "Emergency Contract Person Name must be at least 3 characters long"
    ),

  contact_contract_relation: yup
    .string()
    .required("Relation with Volunteer is required"),

  active_fg: yup.string().required("Active status is required*"),
});

const VolunteerAdd = () => {
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState();
  const [selectedImageNid, setSelectedImageNid] = useState();
  const [selectedImageCOVID, setSelectedImageCOVID] = useState();
  const [selectedImageFatherOrHusbandNID, setSelectedImageFatherOrHusbandNID] =
    useState();
  const [inputs] = useState([]);
  const [division, setDivision] = useState([]);
  const [divisionId, setDivisionId] = useState("");
  const [district, setDistrict] = useState([]);
  const [districtId, setDistrictId] = useState("");
  const [thana, setThana] = useState([]);
  const [female, setFemale] = useState(false);
  const [isMedicalHistory, setIsMedicalHistory] = useState();
  const [isHealthCondition, setIsHealthCondition] = useState();
  const [isPreviousIllnesses, setisPreviousIllnesses] = useState();
  const [isSurgeries, setIsSurgeries] = useState();
  const [isAllergies, setIsAllergies] = useState();
  const [isCurrentMedications, setIsCurrentMedications] = useState();
  const [isAvailability, setIsAvailability] = useState();
  const [isParticipatedClinicalTrials, setIsParticipatedClinicalTrials] =
    useState();
  const [isCOVID, setIsCOVID] = useState();
  const [isFatherOrHusbandNID, setIsFatherOrHusbandNID] = useState();
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const [volunteerPendingInfo, , isError, error, isSuccess, refetch] =
    useVolunteerPending();
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      availability: "N",
      previous_clinic_trial: "N",
      medical_history: "N",
      pre_clin_trial_detail: "",
      covid_title: "",
      covid_desc: "",
      fathr_or_husb_nid_title: "",
      fathr_or_husb_nid_desc: "",
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleFemale = (e) => {
    const selectValue = e.target.value;
    setFemale(selectValue === "Female");
  };
  const handleMedicalHistory = (e) => {
    const selectValue = e.target.value;
    setIsMedicalHistory(selectValue === "Y");
  };
  const handleHealthCondition = (e) => {
    const selectValue = e.target.value;

    setIsHealthCondition(selectValue === "Y");
  };
  const handlePreviousIllnesses = (e) => {
    const selectValue = e.target.value;
    setisPreviousIllnesses(selectValue === "Y");
  };
  const handleSurgeries = (e) => {
    const selectValue = e.target.value;
    setIsSurgeries(selectValue === "Y");
  };

  const handleAllergies = (e) => {
    const selectValue = e.target.value;
    setIsAllergies(selectValue === "Y");
  };
  const handleCurrentMedications = (e) => {
    const selectValue = e.target.value;
    setIsCurrentMedications(selectValue === "Y");
  };
  const handleAvailability = (e) => {
    const selectValue = e.target.value;
    setIsAvailability(selectValue === "Y");
  };
  const handleParticipatedClinicalTrials = (e) => {
    const selectValue = e.target.value;
    setIsParticipatedClinicalTrials(selectValue === "Y");
  };
  const handleCOVID = (e) => {
    const selectValue = e.target.value;
    setIsCOVID(selectValue === "C");
  };
  const handleFatherOrHusbandNID = (e) => {
    const selectValue = e.target.value;
    setIsFatherOrHusbandNID(selectValue === "F");
  };

  useEffect(() => {
    const getDivision = async () => {
      const resDivision = await fetch(
        `${process.env.REACT_APP_API_URL}/api/divisionList`
      );
      const resDiv = await resDivision.json();
      setDivision(await resDiv);
    };
    getDivision();
  }, []);

  const handleDivision = (event) => {
    const getDivisionId = event.target.value;
    setDivisionId(getDivisionId);
  };

  useEffect(() => {
    if (divisionId) {
      const getDistrict = async () => {
        const resDistrict = await fetch(
          `${process.env.REACT_APP_API_URL}/api/districtList/${divisionId}`
        );
        const resDis = await resDistrict.json();
        setDistrict(await resDis);
      };
      getDistrict();
    }
  }, [divisionId]);

  const handleDistrict = (event) => {
    const getDistrictId = event.target.value;
    setDistrictId(getDistrictId);
  };

  useEffect(() => {
    if (districtId) {
      const getThana = async () => {
        const resThana = await fetch(
          `${process.env.REACT_APP_API_URL}/api/thanaList/${districtId}`
        );
        const resTh = await resThana.json();
        setThana(await resTh);
      };
      getThana();
    }
  }, [districtId]);

  useEffect(() => {}, [inputs]);

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };
  const imageChangeNid = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageNid(e.target.files[0]);
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage();
  };

  const removeSelectedImageNid = () => {
    setSelectedImageNid();
  };

  const imageChangeCOVID = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageCOVID(e.target.files[0]);
    }
  };
  const imageChangeFatherOrHusbandNID = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImageFatherOrHusbandNID(e.target.files[0]);
    }
  };

  const removeSelectedImageCOVID = () => {
    setSelectedImageCOVID();
  };

  const removeSelectedImageFatherOrHusbandNID = () => {
    setSelectedImageFatherOrHusbandNID();
  };

  const { data: occupationInfo = [] } = useQuery({
    queryKey: ["occupationInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/occupationDropdown`
      );
      const data = await res.json();
      return data;
    },
  });

  const { data: proInfo = [] } = useQuery({
    queryKey: ["proInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/proNameList`
      );
      const volData = await res.json();
      const data = await volData.data;
      return data;
    },
  });

  const onSubmit = (data, e) => {
    const reg1 = data?.dor;
    const dateObj = new Date(reg1);
    const dateStr = dateObj.toLocaleDateString("en-CA");
    const reg2 = data?.dob;
    const dateObj1 = new Date(reg2);
    const dateStr1 = dateObj1.toLocaleDateString("en-CA");
    setIsLoading(true);

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("voluntary_image", selectedImage);
    formData.append("voluntary_nid_image", selectedImageNid);
    formData.append("date_of_registration", dateStr);
    formData.append("full_name", data.full_name);
    formData.append("vol_initial", data.vol_initial);
    formData.append("father_name", data.father_name);
    formData.append("sex", data.sex);
    formData.append("v_fathr_or_husb_name", data.v_fathr_or_husb_name);
    formData.append("fathr_or_husb_nid", data.fathr_or_husb_nid);
    formData.append("mother_name", data.mother_name);
    formData.append("marital_status", data.marital_status);
    formData.append("dob", dateStr1);
    formData.append("vol_blood_group", data.vol_blood_group);
    formData.append("nationality", data.nationality);
    formData.append("occupation_name", data.occupation_name);
    formData.append("national_id", data.national_id);
    formData.append("contact_phone", data.contact_phone);
    //new add
    formData.append("email", data.email);
    formData.append("medical_history", data.medical_history);
    formData.append("health_condition", data.health_condition);
    formData.append("previous_illness", data.previous_illness);
    formData.append("surgery_history", data.surgery_history);
    formData.append("curr_medication", data.curr_medication);
    formData.append("allergies", data.allergies);

    formData.append("availability", data.availability);
    formData.append("previous_clinic_trial", data.previous_clinic_trial);
    formData.append("pre_clin_trial_detail", data.pre_clin_trial_detail);
    formData.append("attachment_type_covid", data.covied);
    formData.append("covid_title", data.covid_title);
    formData.append("covid_desc", data.covid_desc);
    formData.append("covid_image", selectedImageCOVID);
    formData.append("attachment_type_nid", data.fatherOrHusbandNID);
    formData.append("fathr_or_husb_nid_title", data.fathr_or_husb_nid_title);
    formData.append("fathr_or_husb_nid_desc", data.fathr_or_husb_nid_desc);

    formData.append("fathr_or_husb_nid_image", selectedImageFatherOrHusbandNID);
    // allergies
    formData.append("pr_city", divisionId);
    formData.append("permanent_district", districtId);
    formData.append("thana_id", data.thana_id);
    formData.append("permanent_postoffice", data.permanent_postoffice);
    formData.append("village_name", data.village_name);
    formData.append("pro_id", data.pro_id);
    formData.append("old_vol_id", data.old_vol_id);
    formData.append("emergency_contract_ph", data.emergency_contract_ph);
    formData.append("emergency_contract_nm", data.emergency_contract_nm);
    formData.append(
      "contact_contract_relation",
      data.contact_contract_relation
    );

    //8-27-2023 add 2 new field

    formData.append("reg_no", data.reg_no);
    formData.append("active_fg", data.active_fg);

    fetch(`${process.env.REACT_APP_API_URL}/api/createVoluntary`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Volunteer add successful!.", {
            position: toast.POSITION.TOP_CENTER,
          });

          refetch().then(() => {
            dispatch(handleAddClose());
          });
        }
        if (data.success === false) {
          toast.error(
            "Oops! There was an issue updating the volunteer information.",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
        }
      })
      .finally(() => setIsLoading(false));
    // dispatch(handleAddClose());
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputFieldDiv>
          <InputDiv>
            <InputContainer style={{ height: "1rem" }}></InputContainer>

            <InputContainer1>
              <InputLevel>Date of Registration</InputLevel>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="dor"
                  control={control}
                  defaultValue={new Date().toLocaleDateString("en-CA")}
                  render={({ field }) => (
                    <>
                      <DesktopDatePicker
                        // label="Date of history"
                        maxDate={new Date()}
                        inputFormat="DD MMM YYYY"
                        value={field.value}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField fullWidth size="small" {...params} />
                        )}
                      />
                      {errors.dor && (
                        <ErrorMessage>{errors.dor.message}</ErrorMessage>
                      )}
                    </>
                  )}
                />
              </LocalizationProvider>
            </InputContainer1>
            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Name*"
                variant="outlined"
                {...register("full_name")}
              />
              {errors.full_name && (
                <ErrorMessage>{errors.full_name.message}</ErrorMessage>
              )}
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Registration Number"
                variant="outlined"
                {...register("reg_no")}
              />
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                fullWidth
                label="Father Name*"
                variant="outlined"
                {...register("father_name")}
              />
              {errors.father_name && (
                <ErrorMessage>{errors.father_name.message}</ErrorMessage>
              )}
            </InputDiv1>

            <InputDiv1>
              <TextField
                size="small"
                {...register("mother_name")}
                fullWidth
                label="Mother Name"
                variant="outlined"
              />
            </InputDiv1>

            <InputDiv1>
              <Controller
                name="marital_status"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    fullWidth
                    label="Marital Status*"
                    size="small"
                  >
                    <MenuItem value="Unmarried">Unmarried</MenuItem>
                    <MenuItem value="Married">Married</MenuItem>
                  </TextField>
                )}
                rules={{ required: true }}
              />
              {errors.marital_status && (
                <ErrorMessage>{errors.marital_status.message}</ErrorMessage>
              )}
            </InputDiv1>
          </InputDiv>

          <InputDiv
            style={{
              maxHeight: "500px",
              lineHeight: "21px",
              padding: "8px 0px 0px 24px",
            }}
          >
            <ImageDivText
              style={{ padding: "6px 0px 0px 12px", marginBottom: ".75rem" }}
            >
              Volunteer image (Upload)
            </ImageDivText>

            <ImageDiv
              style={{
                height: "160px",
              }}
            >
              {!selectedImage && (
                <Tooltip title="Upload image here">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={imageChange}
                    />
                    <PhotoCamera />
                  </IconButton>
                </Tooltip>
              )}

              {selectedImage && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 4fr 1fr",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChange}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div style={{}}>
                    <img
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      src={URL.createObjectURL(selectedImage)}
                      alt="Thumb"
                    />
                  </div>
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Remove this image here">
                      <IconButton onClick={removeSelectedImage}>
                        <HighlightOffIcon
                          sx={{
                            color: "#3490DC",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              )}
            </ImageDiv>

            <ImageDivText
              style={{ padding: "6px 0px 0px 12px", margin: " .25rem 0" }}
            >
              NID/Passport/Birth Certificate Image (Upload)
            </ImageDivText>

            <ImageDiv
              style={{
                height: "160px",
              }}
            >
              {!selectedImageNid && (
                <Tooltip title="Upload image here">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={imageChangeNid}
                    />
                    <PhotoCamera />
                  </IconButton>
                </Tooltip>
              )}

              {selectedImageNid && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 4fr 1fr",
                    gap: ".2rem",
                  }}
                >
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChangeNid}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <div style={{}}>
                    <img
                      style={{
                        height: "120px",
                        maxWidth: "200px",
                      }}
                      src={URL.createObjectURL(selectedImageNid)}
                      alt="Thumb"
                    />
                  </div>
                  <div
                    style={{
                      alignItem: "center",
                      justifyContent: "center",
                      marginTop: "1.5rem",
                    }}
                  >
                    <Tooltip title="Remove this image here">
                      <IconButton onClick={removeSelectedImageNid}>
                        <HighlightOffIcon
                          sx={{
                            color: "#3490DC",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              )}
            </ImageDiv>
          </InputDiv>
        </InputFieldDiv>

        <InputFieldDiv>
          <div>
            <InputDiv>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="dob"
                  control={control}
                  defaultValue={new Date().toLocaleDateString("en-CA")}
                  render={({ field }) => (
                    <>
                      <DesktopDatePicker
                        label="Date of Birth"
                        maxDate={new Date()}
                        inputFormat="DD MMM YYYY"
                        value={field.value}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField fullWidth size="small" {...params} />
                        )}
                      />
                      {errors.dob && (
                        <ErrorMessage>{errors.dob.message}</ErrorMessage>
                      )}
                    </>
                  )}
                />
              </LocalizationProvider>
              {errors?.dob?.type === "required" && (
                <ErrorMessage>Date of birth is required</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <Controller
                name="sex"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    select
                    {...field}
                    fullWidth
                    label="Sex*"
                    size="small"
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </TextField>
                )}
                rules={{
                  required: true,
                  onChange: (e) => handleFemale(e),
                }}
              />
              {errors.sex && <ErrorMessage>{errors.sex.message}</ErrorMessage>}
            </InputDiv>

            {female && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Father/Husband Name*"
                    variant="outlined"
                    {...register("v_fathr_or_husb_name")}
                    error={!!errors.v_fathr_or_husb_name}
                    helperText={errors.v_fathr_or_husb_name?.message || ""}
                  />
                </InputDiv>

                <InputDiv>
                  <StyledInput
                    type="number"
                    size="small"
                    fullWidth
                    label="Father/Husband NID*"
                    variant="outlined"
                    {...register("fathr_or_husb_nid")}
                    error={!!errors.fathr_or_husb_nid}
                    helperText={errors.fathr_or_husb_nid?.message || ""}
                  />
                </InputDiv>
              </>
            )}

            <InputDiv>
              <Controller
                name="vol_blood_group"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    size="small"
                    id="outlined-select-currency"
                    select
                    // defaultValue={0}
                    label="Blood Group*"
                  >
                    <MenuItem value="O+">O+</MenuItem>
                    <MenuItem value="O-">O-</MenuItem>
                    <MenuItem value="A+">A+</MenuItem>
                    <MenuItem value="A-">A-</MenuItem>
                    <MenuItem value="B+">B+</MenuItem>
                    <MenuItem value="B-">B-</MenuItem>
                    <MenuItem value="AB+">AB+</MenuItem>
                    <MenuItem value="AB-">AB-</MenuItem>
                    <MenuItem value="Unknown">Unknown</MenuItem>
                  </TextField>
                )}
                rules={{ required: true }}
              />
              {errors.vol_blood_group && (
                <ErrorMessage>{errors.vol_blood_group.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <TextField
                select
                defaultValue={"Bangladeshi"}
                fullWidth
                size="small"
                label="Nationality*"
                {...register("nationality")}
              >
                <MenuItem value="Bangladeshi">Bangladeshi</MenuItem>
                <MenuItem value="Indian">Indian</MenuItem>
                <MenuItem value="American">American</MenuItem>
                <MenuItem value="Australian">Australian</MenuItem>
              </TextField>
            </InputDiv>

            <InputDiv>
              <Controller
                name="occupation_name"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    fullWidth
                    size="small"
                    label="Occupation*"
                  >
                    {occupationInfo?.map((occupation) => (
                      <MenuItem
                        key={Math.random()}
                        value={occupation.occupation_name}
                      >
                        {occupation.occupation_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                rules={{ required: true }}
              />
              {errors.occupation_name && (
                <ErrorMessage>{errors.occupation_name.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="NID*"
                variant="outlined"
                {...register("national_id")}
              />
              {errors.national_id && (
                <ErrorMessage>{errors.national_id.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="Contact Number*"
                variant="outlined"
                {...register("contact_phone")}
              />
              {errors.contact_phone && (
                <ErrorMessage>{errors.contact_phone.message}</ErrorMessage>
              )}
            </InputDiv>
            <InputDiv>
              <StyledInput
                type="email"
                size="small"
                fullWidth
                label="Email"
                variant="outlined"
                {...register("email")}
              />
              {errors.email && (
                <ErrorMessage>{errors.email.message}</ErrorMessage>
              )}
            </InputDiv>
            <InputDiv>
              <StyledInput
                type="text"
                size="small"
                fullWidth
                label="Emergency Contact Person*"
                variant="outlined"
                {...register("emergency_contract_nm")}
              />
              {errors.emergency_contract_nm && (
                <ErrorMessage>
                  {errors.emergency_contract_nm.message}
                </ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <StyledInput
                type="number"
                size="small"
                fullWidth
                label="Emergency Contact Number*"
                variant="outlined"
                {...register("emergency_contract_ph")}
              />
              {errors.emergency_contract_ph && (
                <ErrorMessage>
                  {errors.emergency_contract_ph.message}
                </ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Relation with Volunteer*"
                variant="outlined"
                {...register("contact_contract_relation")}
              />
              {errors.contact_contract_relation && (
                <ErrorMessage>
                  {errors.contact_contract_relation.message}
                </ErrorMessage>
              )}
            </InputDiv>
            <InputDiv>
              <ImageDivText style={{ padding: "5px 0px 0px 0px" }}>
                Medical History
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                defaultValue=""
                select
                label="Medical History"
                {...register("medical_history", {})}
                onChange={(e) => handleMedicalHistory(e)}
              >
                <MenuItem value="Y">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>

            {isMedicalHistory && (
              <>
                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    defaultValue=""
                    id="outlined-select-currency"
                    select
                    label="Any Relevant Health Conditions"
                    {...register("health_conditions", {})}
                    onChange={(e) => handleHealthCondition(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {isHealthCondition && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Specify"
                        defaultValue=""
                        variant="outlined"
                        {...register("health_condition")}
                        error={!!errors.health_condition}
                        helperText={errors.health_condition?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}

                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-select-currency"
                    defaultValue=""
                    select
                    label="Previous Illnesses"
                    {...register("previous_illnesses", {})}
                    onChange={(e) => handlePreviousIllnesses(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {isPreviousIllnesses && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Specify"
                        defaultValue=""
                        variant="outlined"
                        {...register("previous_illness")}
                        error={!!errors.previous_illness}
                        helperText={errors.previous_illness?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}
                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-select-currency"
                    defaultValue=""
                    select
                    label="Surgeries"
                    {...register("surgeries", {})}
                    onChange={(e) => handleSurgeries(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {isSurgeries && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Specify"
                        defaultValue=""
                        variant="outlined"
                        {...register("surgery_history")}
                        error={!!errors.surgery_history}
                        helperText={errors.surgery_history?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}

                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-select-currency"
                    defaultValue=""
                    select
                    label="Allergies"
                    {...register("allergiess", {})}
                    onChange={(e) => handleAllergies(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>
                {isAllergies && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Specify"
                        variant="outlined"
                        defaultValue=""
                        {...register("allergies")}
                        error={!!errors.allergies}
                        helperText={errors.allergies?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}

                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-select-currency"
                    defaultValue=""
                    select
                    label="Current Medications"
                    {...register("current_medications", {})}
                    onChange={(e) => handleCurrentMedications(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {isCurrentMedications && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Specify"
                        variant="outlined"
                        {...register("curr_medication")}
                        error={!!errors.curr_medication}
                        helperText={errors.curr_medication?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}
              </>
            )}
          </div>

          <div>
            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Old Volunteer Id"
                variant="outlined"
                {...register("old_vol_id", {})}
              />
            </InputDiv>

            <InputDiv>
              <TextField
                select
                size="small"
                fullWidth
                label="PRO Name"
                defaultValue=""
                variant="outlined"
                {...register("pro_id")}
              >
                {proInfo.map((pro) => (
                  <MenuItem key={Math.random()} value={pro.pro_id}>
                    {pro.pro_name}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                select
                size="small"
                fullWidth
                label="Active Status*"
                variant="outlined"
                {...register("active_fg")}
              >
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="0">Inactive</MenuItem>
              </TextField>
              {errors?.active_fg && (
                <ErrorMessage>{errors.active_fg.message}</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <ImageDivText style={{ padding: "5px 0px 0px 0px" }}>
                Availability
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <TextField
                fullWidth
                size="small"
                defaultValue=""
                id="outlined-select-currency"
                select
                label="Availability for participation in clinical trials"
                {...register("availability", {})}
                onChange={(e) => handleAvailability(e)}
              >
                <MenuItem value="Y">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>
            {isAvailability && (
              <>
                <InputDiv>
                  <TextField
                    fullWidth
                    size="small"
                    defaultValue=""
                    id="outlined-select-currency"
                    select
                    label="Have you previously participated in clinical trials?"
                    {...register("previous_clinic_trial", {})}
                    onChange={(e) => handleParticipatedClinicalTrials(e)}
                  >
                    <MenuItem value="Y">Yes</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </TextField>
                </InputDiv>

                {isParticipatedClinicalTrials && (
                  <>
                    <InputDiv>
                      <TextField
                        size="small"
                        fullWidth
                        label="Please provide details"
                        defaultValue=""
                        variant="outlined"
                        {...register("pre_clin_trial_detail")}
                        error={!!errors.pre_clin_trial_detail}
                        helperText={errors.pre_clin_trial_detail?.message || ""}
                      />
                    </InputDiv>
                  </>
                )}
              </>
            )}

            <InputDiv>
              <ImageDivText style={{ padding: "5px 0px 0px 0px" }}>
                Present Address
              </ImageDivText>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="Division"
                onChange={(e) => handleDivision(e)}
              >
                {division.map((division) => (
                  <MenuItem key={Math.random()} value={division.divsion_id}>
                    {division.divsion_nm}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="District"
                onChange={(e) => handleDistrict(e)}
              >
                {district.map((district, index) => (
                  <MenuItem key={Math.random()} value={district.dzila_code}>
                    {district.dzila_name}
                  </MenuItem>
                ))}
              </TextField>
            </InputDiv>

            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="Police Station"
                {...register("thana_id", {})}
              >
                {thana.map((thana) => (
                  <MenuItem key={Math.random()} value={thana.thana_code}>
                    {thana.thana_name}
                  </MenuItem>
                ))}
              </TextField>
              {errors?.thana_id && (
                <ErrorMessage>Police Station is required</ErrorMessage>
              )}
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Post Office"
                variant="outlined"
                {...register("permanent_postoffice")}
              />
            </InputDiv>

            <InputDiv>
              <TextField
                size="small"
                fullWidth
                label="Village"
                variant="outlined"
                {...register("village_name")}
              />
            </InputDiv>

            <InputDiv>
              <ImageDivText style={{ padding: "5px 0px 0px 0px" }}>
                Attachment
              </ImageDivText>
            </InputDiv>
            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="COVID-19 vaccine card"
                {...register("covied", {})}
                onChange={(e) => handleCOVID(e)}
              >
                <MenuItem value="C">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>

            {isCOVID && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    {...register("covid_title")}
                    fullWidth
                    label="COVID-19 Vaccine Card Title"
                    variant="outlined"
                  />
                </InputDiv>
              
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Description"
                    variant="outlined"
                    {...register("covid_desc")}
                   
                  />
                </InputDiv>
                <ImageDiv
                  style={{
                    height: "160px",
                    margin: "10px 0px 0px 25px",
                  }}
                >
                  {!selectedImageCOVID && (
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChangeCOVID}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  )}

                  {selectedImageCOVID && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 4fr 1fr",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeCOVID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div style={{}}>
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={URL.createObjectURL(selectedImageCOVID)}
                          alt="Thumb"
                        />
                      </div>
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Remove this image here">
                          <IconButton onClick={removeSelectedImageCOVID}>
                            <HighlightOffIcon
                              sx={{
                                color: "#3490DC",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </ImageDiv>
              </>
            )}
            <InputDiv>
              <TextField
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="Father/ Husband NID"
                {...register("fatherOrHusbandNID", {})}
                onChange={(e) => handleFatherOrHusbandNID(e)}
              >
                <MenuItem value="F">Yes</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </InputDiv>
            {isFatherOrHusbandNID && (
              <>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Father/ Husband NID Title*"
                    variant="outlined"
                    {...register("fathr_or_husb_nid_title")}
                
                  />
                </InputDiv>
                <InputDiv>
                  <TextField
                    size="small"
                    fullWidth
                    label="Description"
                    variant="outlined"
                    {...register("fathr_or_husb_nid_desc")}
                   
                  />
                </InputDiv>
                <ImageDiv
                  style={{
                    height: "160px",
                    margin: "10px 0px 0px 25px",
                  }}
                >
                  {!selectedImageFatherOrHusbandNID && (
                    <Tooltip title="Upload image here">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={imageChangeFatherOrHusbandNID}
                        />
                        <PhotoCamera />
                      </IconButton>
                    </Tooltip>
                  )}

                  {selectedImageFatherOrHusbandNID && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 4fr 1fr",
                        gap: ".2rem",
                      }}
                    >
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Upload image here">
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              type="file"
                              onChange={imageChangeFatherOrHusbandNID}
                            />
                            <PhotoCamera />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div style={{}}>
                        <img
                          style={{
                            height: "120px",
                            maxWidth: "200px",
                          }}
                          src={URL.createObjectURL(
                            selectedImageFatherOrHusbandNID
                          )}
                          alt="Thumb"
                        />
                      </div>
                      <div
                        style={{
                          alignItem: "center",
                          justifyContent: "center",
                          marginTop: "1.5rem",
                        }}
                      >
                        <Tooltip title="Remove this image here">
                          <IconButton
                            onClick={removeSelectedImageFatherOrHusbandNID}
                          >
                            <HighlightOffIcon
                              sx={{
                                color: "#3490DC",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </ImageDiv>
              </>
            )}
          </div>
        </InputFieldDiv>

        <Box
          marginTop="20px"
          style={{
            margin: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {isLoading ? (
            <ThemButton style={{}}>
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton
              style={
                {
                  // width: "30%",
                }
              }
              type="submit"
            >
              Add Volunteer
            </ThemButton>
          )}
        </Box>

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </form>
    </>
  );
};

export default VolunteerAdd;
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   IconButton,
//   MenuItem,
//   styled,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import { Controller, useForm, } from "react-hook-form";
// import {
//   ErrorMessage,
//   ImageDiv,
//   ImageDivText,
//   InputContainer,
//   InputDiv,
//   InputDiv1,
//   InputFieldDiv,
//   InputLevel,
// } from "./Volunteer.style";
// import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import { PhotoCamera } from "@mui/icons-material";
// import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import { ThemButton } from "../Login/Login.style";
// import { useDispatch } from "react-redux";
// import { handleAddClose } from "../../redux/Reducer/ModalSlice";
// import { useQuery } from "@tanstack/react-query";
// import SyncLoader from "react-spinners/SyncLoader";
// import { toast, ToastContainer, Zoom } from "react-toastify";
// import useVolunteerPending from "../../hooks/useVolunteerPending";

// const StyledInput = styled(TextField)(({ theme }) => ({
//   "input[type=number]": {
//     MozAppearance: "textfield",
//   },
//   "input[type=number]::-webkit-outer-spin-button": {
//     WebkitAppearance: "none",
//     margin: 0,
//   },
//   "input[type=number]::-webkit-inner-spin-button": {
//     WebkitAppearance: "none",
//     margin: 0,
//   },
// }));

// const VolunteerAdd = () => {
//   const dispatch = useDispatch();
//   const [isLoading, setIsLoading] = useState();
//   const [selectedImage, setSelectedImage] = useState();
//   const [selectedImageNid, setSelectedImageNid] = useState();
//   const [reg, setReg] = React.useState(dayjs(new Date()));
//   const [birth, setBirth] = React.useState(dayjs(new Date()));
//   const [inputs] = useState([]);
//   const [division, setDivision] = useState([]);
//   const [divisionId, setDivisionId] = useState("");
//   const [district, setDistrict] = useState([]);
//   const [districtId, setDistrictId] = useState("");
//   const [thana, setThana] = useState([]);
//   const [female, setFemale] = useState(false);

//   const userId = localStorage.getItem("uI");
//   const user_id = userId - 786;

//   const [refetch] = useVolunteerPending();

//   const handleFemale = (e) => {
//     const selectValue = e.target.value;
//     setFemale(selectValue === "Female");
//   };

//   useEffect(() => {
//     const getDivision = async () => {
//       const resDivision = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/divisionList`
//       );
//       const resDiv = await resDivision.json();
//       setDivision(await resDiv);
//     };
//     getDivision();
//   }, []);

//   const handleDivision = (event) => {
//     const getDivisionId = event.target.value;
//     setDivisionId(getDivisionId);
//   };

//   useEffect(() => {
//     if (divisionId) {
//       const getDistrict = async () => {
//         const resDistrict = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/districtList/${divisionId}`
//         );
//         const resDis = await resDistrict.json();
//         setDistrict(await resDis);
//       };
//       getDistrict();
//     }
//   }, [divisionId]);

//   const handleDistrict = (event) => {
//     const getDistrictId = event.target.value;
//     setDistrictId(getDistrictId);
//   };

//   useEffect(() => {
//     if (districtId) {
//       const getThana = async () => {
//         const resThana = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/thanaList/${districtId}`
//         );
//         const resTh = await resThana.json();
//         setThana(await resTh);
//       };
//       getThana();
//     }
//   }, [districtId]);

//   useEffect(() => { }, [inputs]);

//   const handleRegChange = (newValue) => {
//     const dateObj = new Date(newValue);
//     const dateStr = dateObj.toLocaleDateString("en-CA");
//     setReg(dateStr);
//   };
//   const handleBirthChange = (newValue) => {
//     const dateObj = new Date(newValue);
//     const dateStr = dateObj.toLocaleDateString("en-CA");
//     setBirth(dateStr);
//   };

//   const {
//     register,
//     formState: { errors },
//     handleSubmit,
//     control,
//   } = useForm();

//   const imageChange = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//       setSelectedImage(e.target.files[0]);
//     }
//   };
//   const imageChangeNid = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//       setSelectedImageNid(e.target.files[0]);
//     }
//   };

//   const removeSelectedImage = () => {
//     setSelectedImage();
//   };

//   const removeSelectedImageNid = () => {
//     setSelectedImageNid();
//   };

//   const { data: occupationInfo = [] } = useQuery({
//     queryKey: ["occupationInfo"],
//     queryFn: async () => {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/occupationDropdown`
//       );
//       const data = await res.json();
//       return data;
//     },
//   });

//   const { data: proInfo = [] } = useQuery({
//     queryKey: ["proInfo"],
//     queryFn: async () => {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/proNameList`
//       );
//       const volData = await res.json();
//       const data = await volData.data;
//       return data;
//     },
//   });

//   const onSubmit = (data, e) => {

//     const reg1 = data?.dor
//     const dateObj = new Date(reg1);
//     const dateStr = dateObj.toLocaleDateString("en-CA");
//     const reg2 = data?.dob
//     const dateObj1 = new Date(reg2);
//     const dateStr1 = dateObj1.toLocaleDateString("en-CA");

//     // alert(JSON.stringify(data));
//     setIsLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", user_id);
//     formData.append("voluntary_image", selectedImage);
//     formData.append("voluntary_nid_image", selectedImageNid);
//     formData.append("date_of_registration", dateStr);
//     formData.append("full_name", data.full_name);
//     formData.append("vol_initial", data.vol_initial);
//     formData.append("father_name", data.father_name);
//     formData.append("sex", data.sex);
//     formData.append("v_fathr_or_husb_name", data.v_fathr_or_husb_name);
//     formData.append("fathr_or_husb_nid", data.fathr_or_husb_nid);
//     formData.append("mother_name", data.mother_name);
//     formData.append("marital_status", data.marital_status);
//     formData.append("dob", dateStr1);
//     formData.append("vol_blood_group", data.vol_blood_group);
//     formData.append("nationality", data.nationality);
//     formData.append("occupation_name", data.occupation_name);
//     formData.append("national_id", data.national_id);
//     formData.append("contact_phone", data.contact_phone);
//     formData.append("pr_city", divisionId);
//     formData.append("permanent_district", districtId);
//     formData.append("thana_id", data.thana_id);
//     formData.append("permanent_postoffice", data.permanent_postoffice);
//     formData.append("village_name", data.village_name);
//     formData.append("pro_id", data.pro_id);
//     formData.append("old_vol_id", data.old_vol_id);
//     formData.append("emergency_contract_ph", data.emergency_contract_ph);
//     formData.append("emergency_contract_nm", data.emergency_contract_nm);
//     formData.append(
//       "contact_contract_relation",
//       data.contact_contract_relation
//     );

//     //8-27-2023 add 2 new field

//     formData.append(
//       "reg_no",
//       data.reg_no
//     );
//     formData.append(
//       "active_fg",
//       data.active_fg
//     );

//     fetch(
//       `${process.env.REACT_APP_API_URL}/api/createVoluntary`,
//       {
//         method: "POST",
//         body: formData,
//       }
//     )
//       .then((res) => {
//         return res.json();
//       })
//       .then((data) => {
//         if (data.success === true) {
//           // refetch();
//           dispatch(handleAddClose());
//           refetch();
//         }
//         if (data.success === false) {
//           toast.error("volunteer not add!!", {
//             position: toast.POSITION.TOP_CENTER,
//           });
//         }
//       })
//       .finally(() => setIsLoading(false));
//     dispatch(handleAddClose());
//   };

//   return (
//     <>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <InputFieldDiv >
//           <InputDiv>
//             <InputContainer style={{ height: "1rem" }}></InputContainer>

//             <InputContainer>
//               <InputLevel>Date of Registration</InputLevel>

//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <DesktopDatePicker
//                   // label="Date of Birth"
//                   inputFormat="DD MMM YYYY"
//                   value={reg}
//                   maxDate={new Date()}
//                   onChange={handleRegChange}
//                   renderInput={(params) => (
//                     <TextField fullWidth size="small" {...params} />
//                   )}
//                 />
//               </LocalizationProvider>
//             </InputContainer>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Name*"
//                 variant="outlined"
//                 {...register("full_name", {
//                   required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.full_name?.type === "required" && (
//                 <ErrorMessage>Name is required</ErrorMessage>
//               )}
//               {errors?.full_name?.type === "minLength" && (
//                 <ErrorMessage>Name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Registration Number"
//                 variant="outlined"
//                 {...register("reg_no", {
//                   // required: true,
//                   // minLength: 3,
//                 })}
//               />
//               {errors?.reg_no?.type === "minLength" && (
//                 <ErrorMessage>Name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Father Name"
//                 variant="outlined"
//                 {...register("father_name", {
//                   // required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.father_name?.type === "required" && (
//                 <ErrorMessage>Father Name is required</ErrorMessage>
//               )}
//               {errors?.father_name?.type === "minLength" && (
//                 <ErrorMessage>Father name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <TextField
//                 size="small"
//                 {...register("mother_name", {
//                   // required: true,
//                   minLength: 3,
//                 })}
//                 fullWidth
//                 label="Mother Name"
//                 variant="outlined"
//               />
//               {errors?.vol_initial?.type === "required" && (
//                 <ErrorMessage>Product Name is required</ErrorMessage>
//               )}
//               {errors?.mother_name?.type === "minLength" && (
//                 <ErrorMessage>Mother name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv1>

//             <InputDiv1>
//               <Controller
//                 name="marital_status"
//                 control={control}
//                 defaultValue=""
//                 render={({ field }) => (
//                   <TextField
//                     select
//                     {...field}
//                     fullWidth
//                     label="Marital Status*"
//                     size="small"
//                   >
//                     <MenuItem value="Unmarried">Unmarried</MenuItem>
//                     <MenuItem value="Married">Married</MenuItem>
//                   </TextField>
//                 )}
//                 rules={{ required: true }}
//               />
//               {errors?.marital_status?.type === "required" && (
//                 <ErrorMessage>Marital status is required</ErrorMessage>
//               )}
//             </InputDiv1>

//           </InputDiv>

//           <InputDiv
//             style={{
//               maxHeight: "500px",
//               lineHeight: "21px",
//               padding: "8px 0px 0px 24px",
//             }}
//           >
//             <ImageDivText
//               style={{ padding: "6px 0px 0px 12px", marginBottom: ".75rem" }}
//             >
//               Volunteer image (Upload)
//             </ImageDivText>

//             <ImageDiv
//               style={{
//                 height: "160px",
//               }}
//             >
//               {!selectedImage && (
//                 <Tooltip title="Upload image here">
//                   <IconButton
//                     color="primary"
//                     aria-label="upload picture"
//                     component="label"
//                   >
//                     <input
//                       hidden
//                       accept="image/*"
//                       type="file"
//                       onChange={imageChange}
//                     />
//                     <PhotoCamera />
//                   </IconButton>
//                 </Tooltip>
//               )}

//               {selectedImage && (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 4fr 1fr",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChange}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div style={{}}>
//                     <img
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       src={URL.createObjectURL(selectedImage)}
//                       alt="Thumb"
//                     />
//                   </div>
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Remove this image here">
//                       <IconButton onClick={removeSelectedImage}>
//                         <HighlightOffIcon
//                           sx={{
//                             color: "#3490DC",
//                           }}
//                         />
//                       </IconButton>
//                     </Tooltip>
//                   </div>
//                 </div>
//               )}
//             </ImageDiv>

//             <ImageDivText
//               style={{ padding: "6px 0px 0px 12px", margin: " .25rem 0" }}
//             >
//               NID/Passport/Birth Certificate Image (Upload)
//             </ImageDivText>

//             <ImageDiv
//               style={{
//                 height: "160px",
//               }}
//             >
//               {!selectedImageNid && (
//                 <Tooltip title="Upload image here">
//                   <IconButton
//                     color="primary"
//                     aria-label="upload picture"
//                     component="label"
//                   >
//                     <input
//                       hidden
//                       accept="image/*"
//                       type="file"
//                       onChange={imageChangeNid}
//                     />
//                     <PhotoCamera />
//                   </IconButton>
//                 </Tooltip>
//               )}

//               {selectedImageNid && (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 4fr 1fr",
//                     gap: ".2rem",
//                   }}
//                 >
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Upload image here">
//                       <IconButton
//                         color="primary"
//                         aria-label="upload picture"
//                         component="label"
//                       >
//                         <input
//                           hidden
//                           accept="image/*"
//                           type="file"
//                           onChange={imageChangeNid}
//                         />
//                         <PhotoCamera />
//                       </IconButton>
//                     </Tooltip>
//                   </div>

//                   <div style={{}}>
//                     <img
//                       style={{
//                         height: "120px",
//                         maxWidth: "200px",
//                       }}
//                       src={URL.createObjectURL(selectedImageNid)}
//                       alt="Thumb"
//                     />
//                   </div>
//                   <div
//                     style={{
//                       alignItem: "center",
//                       justifyContent: "center",
//                       marginTop: "1.5rem",
//                     }}
//                   >
//                     <Tooltip title="Remove this image here">
//                       <IconButton onClick={removeSelectedImageNid}>
//                         <HighlightOffIcon
//                           sx={{
//                             color: "#3490DC",
//                           }}
//                         />
//                       </IconButton>
//                     </Tooltip>
//                   </div>
//                 </div>
//               )}
//             </ImageDiv>
//           </InputDiv>
//         </InputFieldDiv>

//         <InputFieldDiv>
//           <div>
//             <InputDiv>
//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <DesktopDatePicker
//                   label="Date of Birth"
//                   inputFormat="DD MMM YYYY"
//                   value={birth}
//                   maxDate={new Date()}
//                   onChange={handleBirthChange}
//                   renderInput={(params) => (
//                     <TextField fullWidth size="small" {...params} />
//                   )}
//                 // {...register("dob", {})}
//                 />
//               </LocalizationProvider>
//               {errors?.dob?.type === "required" && (
//                 <ErrorMessage>Date of birth is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <Controller
//                 name="sex"
//                 control={control}
//                 defaultValue=""
//                 render={({ field }) => (
//                   <TextField
//                     select
//                     {...field}
//                     fullWidth
//                     label="Sex*"
//                     size="small"
//                   >
//                     <MenuItem value="Male">Male</MenuItem>
//                     <MenuItem value="Female">Female</MenuItem>
//                     <MenuItem value="Others">Others</MenuItem>
//                   </TextField>
//                 )}
//                 rules={{
//                   required: true,
//                   onChange: (e) => handleFemale(e),
//                 }}
//               />
//               {errors?.sex?.type === "required" && (
//                 <ErrorMessage>Sex is required</ErrorMessage>
//               )}
//             </InputDiv>

//             {female && (
//               <>
//                 <InputDiv>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     label="Father/Husband Name"
//                     variant="outlined"
//                     {...register("v_fathr_or_husb_name", {
//                       required: true,
//                       minLength: 3,
//                     })}
//                   />
//                   {errors?.v_fathr_or_husb_name?.type === "required" && (
//                     <ErrorMessage>Father/Husband Name is required</ErrorMessage>
//                   )}
//                   {errors?.v_fathr_or_husb_name?.type === "minLength" && (
//                     <ErrorMessage>
//                       Father/Husband Name must be 3 digit
//                     </ErrorMessage>
//                   )}
//                 </InputDiv>

//                 <InputDiv>
//                   <StyledInput
//                     type="number"
//                     size="small"
//                     fullWidth
//                     label="Father/Husband NID*"
//                     variant="outlined"
//                     {...register("fathr_or_husb_nid", {
//                       required: true,
//                       maxLength: 20,
//                       minLength: 9,
//                     })}
//                   />
//                   {errors?.fathr_or_husb_nid?.type === "required" && (
//                     <ErrorMessage>Father/Husband NID is required</ErrorMessage>
//                   )}
//                   {errors?.fathr_or_husb_nid?.type === "maxLength" && (
//                     <ErrorMessage>
//                       Father/Husband NID must be between 9-20 digit
//                     </ErrorMessage>
//                   )}
//                   {errors?.fathr_or_husb_nid?.type === "minLength" && (
//                     <ErrorMessage>
//                       Father/Husband NID must be between 9-20 digit
//                     </ErrorMessage>
//                   )}
//                 </InputDiv>
//               </>
//             )}

//             <InputDiv>
//               <Controller
//                 name="vol_blood_group"
//                 control={control}
//                 defaultValue=""
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     fullWidth
//                     size="small"
//                     id="outlined-select-currency"
//                     select
//                     // defaultValue={0}
//                     label="Blood Group*"
//                   // {...register("vol_blood_group", {})}
//                   >
//                     <MenuItem value="O+">O+</MenuItem>
//                     <MenuItem value="O-">O-</MenuItem>
//                     <MenuItem value="A+">A+</MenuItem>
//                     <MenuItem value="A-">A-</MenuItem>
//                     <MenuItem value="B+">B+</MenuItem>
//                     <MenuItem value="B-">B-</MenuItem>
//                     <MenuItem value="AB+">AB+</MenuItem>
//                     <MenuItem value="AB-">AB-</MenuItem>
//                     <MenuItem value="Unknown">Unknown</MenuItem>
//                   </TextField>
//                 )}
//                 rules={{ required: true }}
//               />
//               {errors?.vol_blood_group?.type === "required" && (
//                 <ErrorMessage>Blood group is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 defaultValue={"Bangladeshi"}
//                 fullWidth
//                 size="small"
//                 label="Nationality*"
//                 {...register("nationality", { required: true })}
//               >
//                 <MenuItem value="Bangladeshi">Bangladeshi</MenuItem>
//                 <MenuItem value="Indian">Indian</MenuItem>
//                 <MenuItem value="American">American</MenuItem>
//                 <MenuItem value="Australian">Australian</MenuItem>
//               </TextField>
//               {errors?.nationality?.type === "required" && (
//                 <ErrorMessage>Nationality is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <Controller
//                 name="occupation_name"
//                 control={control}
//                 defaultValue=""
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     fullWidth
//                     size="small"
//                     label="Occupation*"
//                   >
//                     {occupationInfo.map((occupation) => (
//                       <MenuItem
//                         key={Math.random()}
//                         value={occupation.occupation_name}
//                       >
//                         {occupation.occupation_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//                 rules={{ required: true }}
//               />
//               {errors?.occupation_name?.type === "required" && (
//                 <ErrorMessage>Occupation name is required</ErrorMessage>
//               )}
//               {errors?.occupation_name?.type === "minLength" && (
//                 <ErrorMessage>Occupation name is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="NID*"
//                 variant="outlined"
//                 {...register("national_id", {
//                   required: true,
//                   maxLength: 20,
//                   minLength: 9,
//                 })}
//               />
//               {errors?.national_id?.type === "required" && (
//                 <ErrorMessage>National Id is required</ErrorMessage>
//               )}
//               {errors?.national_id?.type === "maxLength" && (
//                 <ErrorMessage>
//                   National Id must be between 9-20 digit
//                 </ErrorMessage>
//               )}
//               {errors?.national_id?.type === "minLength" && (
//                 <ErrorMessage>
//                   National Id must be between 9-20 digit
//                 </ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="Contact Number*"
//                 variant="outlined"
//                 {...register("contact_phone", {
//                   required: true,
//                   maxLength: 11,
//                   minLength: 11,
//                 })}
//               />
//               {errors?.contact_phone?.type === "required" && (
//                 <ErrorMessage>Phone number is required</ErrorMessage>
//               )}
//               {errors?.contact_phone?.type === "maxLength" && (
//                 <ErrorMessage>Phone number maximum 11 digit</ErrorMessage>
//               )}
//               {errors?.contact_phone?.type === "minLength" && (
//                 <ErrorMessage>Phone number must be 11 digit</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <StyledInput
//                 type="number"
//                 size="small"
//                 fullWidth
//                 label="Emergency Contact Number*"
//                 variant="outlined"
//                 {...register("emergency_contract_ph", {
//                   required: true,
//                   maxLength: 11,
//                   minLength: 11,
//                 })}
//               />
//               {errors?.emergency_contract_ph?.type === "required" && (
//                 <ErrorMessage>Relative Phone number is required</ErrorMessage>
//               )}
//               {errors?.emergency_contract_ph?.type === "maxLength" && (
//                 <ErrorMessage>
//                   Relative Phone number maximum 11 digit
//                 </ErrorMessage>
//               )}
//               {errors?.emergency_contract_ph?.type === "minLength" && (
//                 <ErrorMessage>
//                   Relative Phone number must be 11 digit
//                 </ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Relative Name"
//                 variant="outlined"
//                 {...register("emergency_contract_nm", {
//                   // required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.emergency_contract_nm?.type === "required" && (
//                 <ErrorMessage>Relative Name is required</ErrorMessage>
//               )}
//               {errors?.emergency_contract_nm?.type === "minLength" && (
//                 <ErrorMessage>Relative Name must be 3 digit</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Relation with Volunteer*"
//                 variant="outlined"
//                 {...register("contact_contract_relation", {
//                   required: true,
//                   minLength: 3,
//                 })}
//               />
//               {errors?.contact_contract_relation?.type === "required" && (
//                 <ErrorMessage>Relation with Volunteer is required</ErrorMessage>
//               )}
//               {errors?.contact_contract_relation?.type === "minLength" && (
//                 <ErrorMessage>
//                   Relation with Volunteer must be 3 digit
//                 </ErrorMessage>
//               )}
//             </InputDiv>
//           </div>

//           <div>
//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Old Volunteer Id"
//                 variant="outlined"
//                 {...register("old_vol_id", {
//                   // required: true,
//                 })}
//               />
//               {errors?.old_vol_id?.type === "required" && (
//                 <ErrorMessage>Postoffice is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 select
//                 size="small"
//                 fullWidth
//                 label="PRO Name"
//                 variant="outlined"
//                 {...register("pro_id", {
//                   // required: true,
//                 })}
//               >
//                 {proInfo.map((pro) => (
//                   <MenuItem key={Math.random()} value={pro.pro_id}>
//                     {pro.pro_name}
//                   </MenuItem>
//                 ))}
//               </TextField>

//               {errors?.pro_id?.type === "required" && (
//                 <ErrorMessage>Pro name is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>

//               <TextField
//                 select
//                 defaultValue={1}
//                 size="small"
//                 fullWidth
//                 label="Active Status"
//                 variant="outlined"
//                 {...register("active_fg", { required: true })}
//               >
//                 <MenuItem value="1">Active</MenuItem>
//                 <MenuItem value="0">Inactive</MenuItem>
//               </TextField>
//               {errors?.active_fg?.type === "required" && (
//                 <ErrorMessage>Active status is required</ErrorMessage>
//               )}

//             </InputDiv>

//             <InputDiv>
//               <ImageDivText style={{ padding: "20px 0px 0px 24px" }}>
//                 Present Address
//               </ImageDivText>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 label="Division"
//                 onChange={(e) => handleDivision(e)}
//               >
//                 {division.map((division) => (
//                   <MenuItem key={Math.random()} value={division.divsion_id}>
//                     {division.divsion_nm}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 label="District"
//                 onChange={(e) => handleDistrict(e)}
//               >
//                 {district.map((district, index) => (
//                   <MenuItem key={Math.random()} value={district.dzila_code}>
//                     {district.dzila_name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 fullWidth
//                 size="small"
//                 id="outlined-select-currency"
//                 select
//                 label="Police Station"
//                 {...register("thana_id", {})}
//               >
//                 {thana.map((thana) => (
//                   <MenuItem key={Math.random()} value={thana.thana_code}>
//                     {thana.thana_name}
//                   </MenuItem>
//                 ))}
//               </TextField>
//               {errors?.thana_id?.type === "required" && (
//                 <ErrorMessage>Police Station is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Post"
//                 variant="outlined"
//                 {...register("permanent_postoffice", {
//                   // required: true,
//                 })}
//               />
//               {errors?.permanent_postoffice?.type === "required" && (
//                 <ErrorMessage>Postoffice is required</ErrorMessage>
//               )}
//             </InputDiv>

//             <InputDiv>
//               <TextField
//                 size="small"
//                 fullWidth
//                 label="Village"
//                 variant="outlined"
//                 {...register("village_name", {
//                   // required: true,
//                 })}
//               />
//               {errors?.village_name?.type === "required" && (
//                 <ErrorMessage>Village name is required</ErrorMessage>
//               )}
//             </InputDiv>
//           </div>
//         </InputFieldDiv>

//         <Box
//           marginTop="20px"
//           style={{
//             margin: "1.5rem",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "1rem",
//           }}
//         >
//           {isLoading ? (
//             <ThemButton style={{}}>
//               <SyncLoader color="#FFFFFF" size={8} />
//             </ThemButton>
//           ) : (
//             <ThemButton
//               style={
//                 {
//                   // width: "30%",
//                 }
//               }
//               type="submit"
//             >
//               Add Volunteer
//             </ThemButton>
//           )}
//         </Box>

//         <ToastContainer
//           autoClose={2000}
//           limit={1}
//           transition={Zoom}
//           toastStyle={{ border: "2px solid crimson" }}
//         />
//       </form>
//     </>
//   );
// };

// export default VolunteerAdd;
